'use client';
import { createContext } from '@bitmap/utils/utils/createContext';
import { FetchProductVariantGridSchema } from '@bitmap/contracts';
import { z } from 'zod';

export type IProductCardContext = {
  productVariant: z.TypeOf<typeof FetchProductVariantGridSchema>;
  isHovered: boolean;
  currency: {
    iso: string;
    conversionRate: number;
  };
};

export const [ProductCardContext, useProductCardContext] =
  createContext<IProductCardContext>();
